import React, {useState} from 'react'
import Error from '../component/shared/error'

const withErrorHandling = (Component) => {
  return (props) => {
    const [error, setError] = useState(null)

    const handleError = (fn) => {
      return async function () {
        const args = Array.from(arguments)
        try {
          const output = fn.apply(fn.thisArg, args)
          if (output instanceof Promise) {
            try {
              await output
            } catch (e) {
              setError(e)
            }
          }
          return output
        } catch (e) {
          setError(e)
        }
      }
    }

    props = {...props, handleError, setError}
    if (error) {
      return (
        <Error error={error} onClose={() => setError(null)}/>
      )
    }
    return (
      <Component {...props}/>
    )
  }
}

export {withErrorHandling}

export default withErrorHandling